<template>
  <div :class="notAvailable?'notAvailable':''" class="expired-detail cp-job-detail-card">
    <div v-if="notAvailable" style="margin: 0 -30px;background:#edeff4">
      <JobError is-not-available />
          <div class="expired-job-title mb-2">
          {{ jobResult.jobtitletext }}
      </div>
      <div class="expired-company mb-4">
        {{ companyResult.companyname }}
      </div>
    </div>
    <div v-if="!notAvailable">
      <div class="expired-icon mb-4" />
      <div class="expired-title mb-4">
  {{ cpLang("jd.expired") }}
      </div>
      <div class="expired-job-title mb-2">
          {{ jobResult.jobtitletext }}
      </div>
      <div class="expired-company mb-4">
        {{ companyResult.companyname }}
      </div>
      <div class="expired-comment">
       {{ cpLang("jd.sorry_expired") }}
      </div>
    </div>
    <CompanyOtherJob v-if="(cdata && cdata.positions && cdata.positions[0]) && !notAvailable" :id="id" :cdata="cdata" />
    <Interested v-if="showPredict" :id="id" @noPredict="showPredict = false" />
  </div>
</template>

<script>
import Interested from '~/components/search/jd/Interested'
import CompanyOtherJob from '~/components/search/jd/CompanyOtherJob'
import JobError from '~/components/search/JobError'
export default {
  components: {
    Interested,
    CompanyOtherJob,
    JobError
  },
  props: {
    notAvailable: {
      default: false,
      type: Boolean
    }
  },
  data: function () {
    return {
      jobResult: {},
      cdata: {},
      companyResult: {},
      showPredict: true
    }
  },
  async mounted() {
    this.jobResult = await this.$store.state.jobs.detail
    this.companyResult = await this.$store.state.jobs.company
    this.cdata = await this.$store.state.jobs.companyOther
  }
}

</script>

<style lang="scss">
  .expired-detail {
    background-color: white;
    border-radius: 5px 5px 0 0;
    width: 100%;
    padding: 30px;
    text-align: center;

    &.notAvailable{
      background:none;
      .cp_jobNotAvailable{
        img{
          margin-bottom: 45px;
    max-width: 100px;

        }
        h1{
          margin-bottom: 45px;

          font-size: 35px;
          font-weight: bold;
          color:black;
        }
      }
         .expired-job-title{
           font-size: 24px;
           background: none;
           margin-bottom: 24px;
         }
             .expired-company {
               font-size: 20px;
               color:#2B59C3;
             }
    }
    .expired-icon {
      margin: 0 auto;
      width: 80px;
      height: 80px;
      background-size: contain;
      background-image: url(/asset/image/icon/expired.png);
      background-repeat: no-repeat;
      background-position: center center;
    }

    .expired-title {
      font-size: 25px;
      font-weight: bold;
    }

    .expired-job-title {
      color: #003979;
      background-color: #CAD3DD;
      font-weight: bold;
      padding: 10px;
      margin: 0 -30px;
    }

    .expired-company {
      font-size: 14px;
    }

    .expired-comment {
      font-size: 14px;
      margin: 20px 0px;
    }
    .otherJob{
      margin: 0 -30px;
      padding: 10px;
      background: white;
    }
  }

</style>
